import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { jsonParser } from "../../../utils/helpers";
import { Box, Skeleton } from "@mui/material";

export default function SelectedPresentationItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const presentation = props.presentation;

  const [thumbnail, setThumbnail] = useState(false);

  useEffect(() => {
    let thumb = null;
    const json = jsonParser(presentation?.json ? presentation.json : {});

    if (json?.thumbnail?.field_media_image) {
      thumb = json.thumbnail?.field_media_image;
      setThumbnail(thumb);
    } else {
      if (presentation.slides.length > 0) {
        const slide_json = jsonParser(presentation.slides[0]?.slide_json);

        if (slide_json?.reveal?.slideThumbnail?.field_media_image) {
          thumb = slide_json?.reveal?.slideThumbnail?.field_media_image;
        } else {
          thumb = `${system.filesystem_root}/${system.subdomain}/presentations/${presentation.id}/${presentation.id}/thumbnails/slide_${presentation.slides[0].id}_thumbnail.jpg`;
        }

        setThumbnail(thumb);
      }
    }
  }, [props.presentation]);

  return (
    <div className="selected-presentation-item" onClick={() => props.removeSelectedPresentationItem(presentation)}>
      <div className="selected-presentation-item-image">
        {thumbnail ? (
          <img src={thumbnail} onError={() => setThumbnail(false)} />
        ) : (
          <img src="./assets/placeholder.jpg" />
        )}
      </div>
      <div className="selected-presentation-item-title">
        {presentation.title.length > 35 ? presentation.title.slice(0, 35) + "..." : presentation.title}
      </div>
      <div className="selected-presentation-item-id">{presentation.id}</div>
    </div>
  );
}
